import React, { useReducer } from 'react';
import { BiShieldQuarter } from 'react-icons/bi';
import AuthenticationService from '../services/AuthenticationService';
import ResponseParser from '../util/ResponseParser';
import { encodeBase64 } from '../util/Generator';

const reducer = (state, action) => {
   switch (action.type) {
      case 'updateField':
         return { ...state, [action.payload.field]: action.payload.value };
      case 'submitEmpty':
         return { ...state, errors: action.payload.errors };
      case 'onError':
         return { ...state, errors: action.payload.errors };
      default:
         return {};
   }
};

export default function Login(props) {
   const [state, dispatch] = useReducer(reducer, {
      username: '',
      password: '',
      partnerId: '',
      errors: [],
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      if (state.partnerId === '') {
         state.errors = [];
         state.errors.push('Partener Id cannot be empty');
         dispatch({ type: 'submitEmpty', payload: { errors: state.errors } });
         return;
      }
      if (state.username === '' || state.password === '') {
         state.errors = [];
         state.errors.push('Username or Password cannot be empty');
         dispatch({ type: 'submitEmpty', payload: { errors: state.errors } });
         return;
      }

      AuthenticationService.login(state)
         .then((res) => {
            return res.text();
         })
         .then((data) => {
            let xmlData = data;
            let response = ResponseParser.parseLoginResponse(xmlData);
            console.log(response);
            response.encoded = encodeBase64(`${state.username}:${state.password}`);
            if (response.responseCode === 1) {
               response.partnerId = state.partnerId;
               sessionStorage.setItem('user', JSON.stringify(response));
               window.location = '/vend';
            } else {
               state.errors = [];
               state.errors.push(response.responseDesc);
               dispatch({ type: 'submitEmpty', payload: { errors: state.errors } });
            }
         })
         .catch((error) => {
            state.errors = [];
            state.errors.push('An error has occured');
            dispatch({ type: 'onError', payload: { errors: state.errors } });
         });
   };

   const handleChange = (e) => {
      const field = e.target.name;
      const value = e.target.value;
      dispatch({ type: 'updateField', payload: { field, value } });
   };

   return (
      <div className='flexbox-container'>
         <div className='flexbox-item flex-form-1'>
            <form onSubmit={handleSubmit}>
               <div className='input-group'>
                  <label htmlFor='partnerId'>Partner Id</label>
                  <input
                     id='partnerId'
                     type='text'
                     name='partnerId'
                     value={state.partnerId}
                     onChange={handleChange}
                  />
               </div>
               <div className='input-group'>
                  <label htmlFor='username'>Username</label>
                  <input
                     id='username'
                     type='text'
                     name='username'
                     value={state.username}
                     onChange={handleChange}
                  />
               </div>
               <div className='input-group'>
                  <label htmlFor='password'>Password</label>
                  <input
                     id='password'
                     name='password'
                     type='password'
                     value={state.password}
                     onChange={handleChange}
                  />
               </div>
               <div>
                  <button className='login-button'>Login</button>
               </div>
               {state.errors.map((error) => {
                  return <div className='error-message'>{error}</div>;
               })}
            </form>
         </div>
         <div className='flexbox-item flex-form-2'>
            <h3 className='login-title'>Login</h3>
            <div className='login-img'>
               <BiShieldQuarter />
            </div>
            <p className='login-message'>
               If you created your account recently make sure it is actived. If login problem
               persist <a href='#'>contact the admin</a>
            </p>
         </div>
      </div>
   );
}
